import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Footer from "../components/layout/Footer";
import { useAuth } from "../contexts/AuthContext";

export default function NotFound() {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    document.title = "Page Not Found | Romaya";
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <main className="flex-1 pt-24 pb-16 flex items-center justify-center">
        <div className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-7xl sm:text-8xl font-black text-teal-600/20 leading-none mb-2 select-none">
            404
          </p>

          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">
            We couldn&apos;t find that page
          </h1>

          <p className="text-gray-500 mb-2">
            The link may be out of date, or the address might have a typo.
          </p>

          {/* Showing the path makes a mistyped or stale link obvious at a glance. */}
          <p className="text-sm text-gray-400 mb-8 break-all">
            <code className="px-2 py-1 bg-gray-100 rounded">{location.pathname}</code>
          </p>

          <div className="flex flex-wrap items-center justify-center gap-3">
            <Link
              to={isAuthenticated ? "/dashboard" : "/"}
              className="inline-flex items-center justify-center px-6 py-3 bg-teal-600 text-white font-semibold rounded-full hover:bg-teal-700 transition-colors shadow-sm cursor-pointer"
            >
              {isAuthenticated ? "Go to Dashboard" : "Back to Home"}
            </Link>

            <Link
              to="/community"
              className="inline-flex items-center justify-center px-6 py-3 border border-gray-300 text-gray-700 font-semibold rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
            >
              Explore Community
            </Link>

            {isAuthenticated && (
              <Link
                to="/plan"
                className="inline-flex items-center justify-center px-6 py-3 border border-gray-300 text-gray-700 font-semibold rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
              >
                Plan a Trip
              </Link>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
